<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="[{ field: 'createdAt', dir: 'desc' }]"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/SharedAccess/queries/sharedAccess.gql')
      }"
      :context="context"
      :headers="$options.headersConfig"
      :filters="{
        profileName: {
          control: 'text',
          modifier: 'contains',
          dataType: String
        },
        profileType: {
          control: 'select',
          options: [...$options.listProfileTypes],
          dataType: String
        },
        status: {
          control: 'select',
          options: [...$options.statusesAccess],
          dataType: String
        },
        createdAt: { control: 'date-range' },
        updatedAt: { control: 'date-range' }
      }"
      @query-state-updated="getStateQuery"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      :views-loading="$async.updateMe.$pending"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          fixed-header
          height="75vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
          v-model="mixSelectedItems"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <!-- <span v-on="on">{{
                  $t(`events-categories.header-titles.${h.value}`)
                }}</span> -->
                <span v-on="on">
                  {{ h.text }}
                </span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.value === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value]) }}
              </div>
              <div v-else-if="h.value === 'login'">
                <router-link title="Открыть" :to="{ name: 'page-accounts', query: { t_login: item[h.value] } }">
                  <template v-if="item?.fullName">{{ item.fullName }}</template> {{  convertToPhone(item[h.value]) }}
                </router-link>
              </div>
              <div v-else-if="h.value === 'profileName'">
                <router-link title="Открыть" :to="toProfile(item)">
                  {{ item.profile.name }}
                </router-link>
              </div>
              <div v-else-if="h.value === 'profileType'">
                {{ getProfileType(item.profile.type)?.text }}
              </div>
              <div v-else-if="h.value === 'status'">
                <a title="Изменить">
                  <v-btn
                    :disabled="item[h.value] !== 'PENDING'"
                    @click="grantSharedAccess(item)">
                    {{ mixGetStatusAccess(item) }}
                  </v-btn>
                </a>
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.type === 'actions'">
                <a title="Удалить">
                  <v-btn icon @click="deleteSharedAccess(item)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else>
                {{ item[h.value] }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <FormDialog
      :isVisible="formDialogVisible"
      @submit="submit"
      @close="$emit('close')"
    />
    <ConfirmationDialog ref="confirmEventRemoving" confirmText="Удалить" />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import { formatAmount } from '@/utils'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig.js'
import FormDialog from '@/pages/shared-access/form-dialog'
import DataTableWrapper from '@/components/data-table-wrapper'
import DataTableFilters from '@/components/data-table-filters'
import DateTimeCell from '@/components/date-time-cell'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import grantSharedAccessMutation from '@/services/gql/types/SharedAccess/mutations/grantSharedAccess.gql'
import deleteSharedAccessMutation from '@/services/gql/types/SharedAccess/mutations/deleteSharedAccess.gql'
import updateMeMutation from '@/services/gql/types/Me/mutations/updateMe.gql'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'
import { getListWithNewMainLanguage } from '@/utils/locales'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { convertToPhone } from '@/configs/numbers'

export default {
  name: 'GridSharedAccess',
  gridType: 'pages',
  perPage,
  headersConfig,
  mixins: [gridDependentMixin],
  props: {
    items: {
      type: Array,
      default: null
    },
    formDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    FormDialog,
    DataTableWrapper,
    DataTableFilters,
    DateTimeCell,
    ConfirmationDialog
  },
  data () {
    return {
      queryState: null
    }
  },
  computed: {
    context () {
      return { headers: { Language: getListWithNewMainLanguage(contentLocales[0].value, contentLocalesValues()) } }
    }
  },
  methods: {
    formatAmount,
    convertToPhone,
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    toProfile (item) {
      return {
        name: this.$options.listProfileTypes.find(type => type.value === item.profile.type)?.name,
        params: { id: item.profile.id }
      }
    },
    getProfileType (profileType) {
      return this.$options.listProfileTypes.find(type => type.value === profileType)
    },
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    submit () {
      this.refetch()
      this.$emit('close')
    },
    async grantSharedAccess (state) {
      try {
        const { data } = await this.$async.grantSharedAccess.$perform({ id: +(state.id) })
        if (data.grantSharedAccess) {
          this.refetch()
        }
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e, `Ошибка в предоставлении общего доступа с ID ${state.id}`)
      }
    },
    async deleteSharedAccess (state) {
      try {
        await this.$async.deleteSharedAccess.$perform({ deleteSharedAccessId: +(state.id) })
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e, `Ошибка при удалении общего доступа с ID ${state.id}`)
      }
    }
  },
  async: {
    grantSharedAccess (variables) {
      return this.$apollo.mutate({
        mutation: grantSharedAccessMutation,
        variables
      })
    },
    deleteSharedAccess (variables) {
      return this.$apollo.mutate({
        mutation: deleteSharedAccessMutation,
        variables
      })
    },
    updateMe (variables) {
      return this.$apollo.mutate({
        mutation: updateMeMutation,
        variables
      })
    }
  }
}
</script>
